import { DnmRequestFailure } from '../../api/dnmFailure';

/** Shipper-final edit (#221, R10 step B): reason 1–500 characters after trimming. */
export const SHIPPER_FREIGHT_REASON_MAX = 500;

export function shipperFreightAmountValid(value: string): boolean {
  if (value.trim() === '') return false;
  const n = Number(value);
  return Number.isInteger(n) && n >= 1;
}

export function shipperFreightReasonValid(reason: string): boolean {
  const t = reason.trim();
  return t.length >= 1 && t.length <= SHIPPER_FREIGHT_REASON_MAX;
}

/** Refusals that no retry can fix: the dialog offers Close instead of Try again. */
export function shipperFreightLocked(error: unknown): boolean {
  return (
    error instanceof DnmRequestFailure &&
    (error.code === 'SHIPPER_INVOICE_ISSUED' || error.code === 'NOT_AWARDED')
  );
}

/** Plain words + next step (UX 3). The API's free-text `error` is never shown. */
export function shipperFreightErrorMessage(error: unknown): string {
  if (error instanceof DnmRequestFailure) {
    if (error.code === 'SHIPPER_INVOICE_ISSUED') {
      return 'The shipper invoice is already issued, so this price is locked. Cancel the invoice in Payments first, or contact support.';
    }
    if (error.code === 'NOT_AWARDED') {
      return 'This order has no awarded bid yet. Award a bid first, then set the shipper final.';
    }
    return error.message;
  }
  return 'Something went wrong. Try again.';
}

export const SHIPPER_FREIGHT_LOCKED_HINT =
  'Shipper invoice already issued — the shipper final can no longer change.';
